import { useMutation, useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreateClientTransport, RemoveClientTransport, UpdateClientTransport } from '../graphql/mutations'
import { GetClientTransports } from '../graphql/queries'
import Button from './Button'
import Input from './Input'
import Modal from './Modal'
import Checkbox from './Checkbox'

const initialTransport = {
    TRANSPORT: null,
    OLD: null,
    KLIENT_ID: null,
    MAIN: null,
}

const rowHeaders = [
    {
        value: 'TRANSPORT',
        label: 'Aadress',
    },
    {
        value: 'OLD',
        label: 'Aegunud',
    },
]

const TransportAddresses = ({ clientId }) => {

    const { t } = useTranslation()
    const [transports, setTransports] = useState([])
    const [selectedTransport, setSelectedTransport] = useState(null)
    const [newTransport, setNewTransport] = useState(initialTransport)
    const [showModal, setShowModal] = useState(false)

    const [createItem] = useMutation(CreateClientTransport)
    const [removeItem] = useMutation(RemoveClientTransport)
    const [updateItem] = useMutation(UpdateClientTransport)

    const { refetch } = useQuery(GetClientTransports, {
        variables: {
            clientId: parseInt(clientId)
        },
        onCompleted: (data) => {
            const { getClientTransports } = data
            if (getClientTransports) setTransports(getClientTransports)
        }
    })

    const handleAdd = async () => {
        try {
            const res = await createItem({
                variables: {
                    data: {
                        ...newTransport,
                        KLIENT_ID: parseInt(clientId),
                    },
                },
            })
            closeModal()
            console.log('handleAdd', res)
        } catch (err) {
            console.log('handleAdd', err)
        }
    }

    const handleDelete = async (id) => {
        try {
            const res = await removeItem({
                variables: {
                    id: parseInt(id),
                },
            })

            console.log('handleDelete', res)
            refetch()
        } catch (err) {
            console.log('handleDelete', err)
        }
    }

    const closeModal = () => {
        setNewTransport(initialTransport)
        setSelectedTransport(null)
        setShowModal(false)
        refetch()
    }

    const setField = (field, value) => {
        setNewTransport({
            ...newTransport,
            [field]: value,
        })
    }

    const setSelectedField = (field, value) => {
        setSelectedTransport({
            ...selectedTransport,
            [field]: value,
        })
    }

    const handleUpdate = async () => {
        try {
            const res = await updateItem({
                variables: {
                    id: parseInt(selectedTransport.ID),
                    data: {
                        TRANSPORT: selectedTransport.TRANSPORT,
                        OLD: selectedTransport.OLD,
                    },
                },
            })
            closeModal()
            console.log('handleAdd', res)
        } catch (err) {
            console.log('handleAdd', err)
        }
    }

    const renderModalActions = () => {
        return (
            <div className='modal-actions justify-content--flex-end'>
                {
                    selectedTransport ?
                    <Button
                        label={t('Uuenda aadressi')}
                        onClick={handleUpdate}
                    />
                    :
                    <Button
                        label={t('Lisa aadress')}
                        onClick={handleAdd}
                    />
                }
            </div>
        )
    }

    return (
        <div className='printouts'>
            <div className='printouts-list'>
                { transports.length > 0 ?
                    <table className='order-rows'>
                        <thead
                            className='order-rows--header'
                            style={{
                                gridTemplateColumns: `repeat(${rowHeaders.length}, 1fr)`
                            }}
                        >
                            <tr>
                            {
                                rowHeaders.map((headerItem) =>
                                    <th key={`header-${headerItem.value}`} className='order-rows--header-item'>
                                        { headerItem.label }
                                    </th>
                                )
                            }
                            <th></th>
                            </tr>
                        </thead>
                        <tbody className='order-rows--content'>
                            {
                                transports.map((row, index) =>
                                    <tr
                                        key={`order-row-${index}`}
                                        className={`order-row`}
                                        onClick={() => {
                                            setSelectedTransport(row)
                                            setShowModal(true)
                                        }}
                                        style={{
                                            gridTemplateColumns: `repeat(${rowHeaders.length}, 1fr)`
                                        }}
                                    >
                                        {
                                            rowHeaders.map((headerItem, itemIndex) =>
                                                <td
                                                    key={`order-row-${index}-${itemIndex}`}
                                                    className='order-row--item'
                                                >
                                                    { row[headerItem.value] }
                                                </td>
                                            )
                                        }
                                        <td>
                                            <Button
                                                label={t('Kustuta')}
                                                onClick={() => handleDelete(row.ID)}
                                            />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className='empty-result'>
                        { t('Transpordi aadresse pole lisatud') }
                    </div>
                }
            </div>
            <Button
                label={t('Lisa transpordi aadress')}
                onClick={() => setShowModal(true)}
            />

            <Modal
                title={selectedTransport ? t('Uuenda aadressi') : t('Lisa transpordi aadress')}
                show={showModal}
                close={closeModal}
                renderActions={renderModalActions}
            >
                {
                    selectedTransport ?
                    <>
                        <Input
                            label={t('Aadress')}
                            value={selectedTransport.TRANSPORT}
                            onChange={(e) => setSelectedField('TRANSPORT', e.target.value)}
                        />
                        <Checkbox
                            label={t('Aegunud')}
                            value={selectedTransport.OLD ? true : false}
                            onChange={(e) => setSelectedField('OLD', e.target.checked ? 1 : 0)}
                        />
                    </>
                    :
                    <>
                        <Input
                            label={t('Aadress')}
                            value={newTransport.TRANSPORT}
                            onChange={(e) => setField('TRANSPORT', e.target.value)}
                        />
                        <Checkbox
                            label={t('Aegunud')}
                            value={newTransport.OLD ? true : false}
                            onChange={(e) => setField('OLD', e.target.checked ? 1 : 0)}
                        />
                    </>
                }
            </Modal>
        </div>
    )
}

export default TransportAddresses